import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon-warning.svg'
import _imports_1 from '@/assets/area/icon-chev-right.svg'
import _imports_2 from '@/assets/area/visitors/icon-persona-triangle.svg'


const _withScopeId = n => (_pushScopeId("data-v-7609ab57"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jr-relative jr-flex jr-justify-evenly jr-mb-3.5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "jr-text-primary jr-font-bold jr-pt-3.5 jr-pl-6 jr-mb-6" }, "エリア来訪者の居住地／勤務地ランキング", -1))
const _hoisted_3 = { class: "jr-flex-1 jr-relative jr-bg-white" }
const _hoisted_4 = { class: "jr-absolute jr-top-0 jr-left-0 jr-flex jr-flex-col jr-bg-white jr-items-center jr-justify-center jr-w-full jr-h-full jr-text-xl jr-text-primary jr-font-bold" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jr-mb-5.5",
  src: _imports_0,
  alt: "icon-warning"
}, null, -1))
const _hoisted_6 = { class: "jr-pl-6 jr-border-b jr-border-gray-sm" }
const _hoisted_7 = { class: "jr-block" }
const _hoisted_8 = { class: "jr-absolute jr-h-0.5 jr-w-full jr-bottom-0 jr-left-0 jr-bg-blue-light" }
const _hoisted_9 = { class: "jr-absolute jr-h-0.5 jr-w-full jr-bottom-0 jr-left-0 jr-bg-blue-light" }
const _hoisted_10 = { class: "ranking jr-px-8 jr-my-7.5 jr-overflow-y-scroll" }
const _hoisted_11 = { class: "ranking jr-px-8 jr-my-7.5 jr-overflow-y-scroll" }
const _hoisted_12 = { class: "jr-flex jr-justify-end jr-items-center jr-border-t jr-border-gray-sm jr-bg-white" }
const _hoisted_13 = { class: "jr-loader jr-ease-linear jr-rounded-full jr-border-4 jr-border-t-4 jr-border-gray-200 jr-h-6 jr-w-6 jr-my-3.5 jr-mx-5" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "jr-mr-1.5 jr-text-sm jr-font-medium jr-text-primary" }, "ランキングの詳細見る", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "icon-chev-right"
}, null, -1))
const _hoisted_16 = { class: "jr-flex-1 jr-relative jr-bg-white" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "jr-text-primary jr-font-bold jr-pt-3.5 jr-pl-6 jr-mb-6" }, "交通手段比率（エリア来訪時／エリア内）", -1))
const _hoisted_18 = { class: "jr-absolute jr-top-0 jr-left-0 jr-flex jr-flex-col jr-items-center jr-justify-center jr-w-full jr-h-full jr-text-xl jr-text-primary jr-font-bold" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jr-mb-5.5",
  src: _imports_0,
  alt: "icon-warning"
}, null, -1))
const _hoisted_20 = { class: "jr-mb-15" }
const _hoisted_21 = { class: "jr-flex jr-justify-end jr-items-center jr-border-t jr-border-gray-sm jr-bg-white" }
const _hoisted_22 = { class: "jr-loader jr-ease-linear jr-rounded-full jr-border-4 jr-border-t-4 jr-border-gray-200 jr-h-6 jr-w-6 jr-my-3.5 jr-mx-5" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "jr-mr-1.5 jr-text-sm jr-font-medium jr-text-primary" }, "交通手段比率の詳細見る", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "icon-chev-right"
}, null, -1))
const _hoisted_25 = { class: "jr-flex jr-justify-evenly jr-mb-3.5" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "jr-text-primary jr-font-bold jr-pt-3.5 jr-pl-6 jr-mb-6" }, "エリア内の訪問施設分析", -1))
const _hoisted_27 = { class: "jr-flex-1 jr-relative jr-bg-white" }
const _hoisted_28 = { class: "jr-px-6.252" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "jr-font-medium jr-text-base jr-text-primary" }, "訪問施設ランキング", -1))
const _hoisted_30 = { class: "jr-absolute jr-top-0 jr-left-0 jr-flex jr-flex-col jr-items-center jr-justify-center jr-w-full jr-h-full jr-text-xl jr-text-primary jr-font-bold" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jr-mb-5.5",
  src: _imports_0,
  alt: "icon-warning"
}, null, -1))
const _hoisted_32 = { class: "jr-flex jr-justify-end jr-items-center jr-border-t jr-border-gray-sm jr-bg-white" }
const _hoisted_33 = { class: "jr-loader jr-ease-linear jr-rounded-full jr-border-4 jr-border-t-4 jr-border-gray-200 jr-h-6 jr-w-6 jr-my-3.5 jr-mx-5" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "jr-mr-1.5 jr-text-sm jr-font-medium jr-text-primary" }, "訪問施設の詳細見る", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "icon-chev-right"
}, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "jr-text-primary jr-font-bold jr-pt-3.5 jr-pl-6 jr-mb-6" }, "エリア内の滞在時間", -1))
const _hoisted_37 = { class: "jr-flex-1 jr-flex jr-items-center jr-justify-center jr-relative jr-bg-white" }
const _hoisted_38 = { class: "jr-absolute jr-w-full jr-h-full jr-top-0 jr-left-0 jr-flex jr-flex-col jr-items-center jr-justify-center jr-text-xl jr-text-primary jr-font-bold" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jr-mb-5.5",
  src: _imports_0,
  alt: "icon-warning"
}, null, -1))
const _hoisted_40 = { class: "jr-flex jr-justify-end jr-items-center jr-border-t jr-border-gray-sm jr-bg-white" }
const _hoisted_41 = { class: "jr-loader jr-ease-linear jr-rounded-full jr-border-4 jr-border-t-4 jr-border-gray-200 jr-h-6 jr-w-6 jr-my-3.5 jr-mx-5" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "jr-mr-1.5 jr-text-sm jr-font-medium jr-text-primary" }, "滞在時間の詳細見る", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "icon-chev-right"
}, null, -1))
const _hoisted_44 = {
  key: 0,
  class: "jr-flex jr-justify-evenly jr-px-4"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "jr-text-primary jr-font-bold jr-pt-3.5 jr-pl-6 jr-mb-6" }, "エリア来訪者の属性（性別・年代・ペルソナ）", -1))
const _hoisted_46 = { class: "grid-box jr-px-9 jr-relative jr-bg-white" }
const _hoisted_47 = { class: "jr-absolute jr-top-0 jr-left-0 jr-flex jr-flex-col jr-items-center jr-justify-center jr-w-full jr-h-full jr-text-xl jr-text-primary jr-font-bold" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jr-mb-5.5",
  src: _imports_0,
  alt: "icon-warning"
}, null, -1))
const _hoisted_49 = { class: "jr-flex" }
const _hoisted_50 = { class: "jr-w-3/5 jr-mr-10" }
const _hoisted_51 = { class: "jr-w-2/5" }
const _hoisted_52 = { class: "jr-relative jr-bg-gray-soft jr-flex jr-flex-wrap jr-justify-center jr-rounded-md jr-px-3.5 jr-pt-7.5 jr-pb-2 jr-mb-10 jr-mt-15" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "icon-persona-triangle",
  class: "jr-absolute jr--top-11 transition triangle"
}, null, -1))
const _hoisted_54 = { class: "jr-flex jr-justify-end jr-items-center jr-border-t jr-border-gray-sm jr-bg-white" }
const _hoisted_55 = { class: "jr-loader jr-ease-linear jr-rounded-full jr-border-4 jr-border-t-4 jr-border-gray-200 jr-h-6 jr-w-6 jr-my-3.5 jr-mx-5" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "jr-mr-1.5 jr-text-sm jr-font-medium jr-text-primary" }, "来訪者属性の詳細見る", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "icon-chev-right"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterNavigation = _resolveComponent("FilterNavigation")!
  const _component_AreaReportSidebar = _resolveComponent("AreaReportSidebar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UILoader = _resolveComponent("UILoader")!
  const _component_TransportationDashboardBarchart = _resolveComponent("TransportationDashboardBarchart")!
  const _component_FacilityBarChart = _resolveComponent("FacilityBarChart")!
  const _component_TimingDoughnutChart = _resolveComponent("TimingDoughnutChart")!
  const _component_VisitorBarChart = _resolveComponent("VisitorBarChart")!
  const _component_VisitorDoughnutChart = _resolveComponent("VisitorDoughnutChart")!
  const _component_UIPersona = _resolveComponent("UIPersona")!
  const _component_AppLoader = _resolveComponent("AppLoader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_FilterNavigation),
    _createVNode(_component_AreaReportSidebar, {
      "loading-detail": _ctx.isLoadingDetail,
      loaded: _ctx.isLoaded,
      onDashboard: _ctx.loadOnDashboard
    }, null, 8, ["loading-detail", "loaded", "onDashboard"]),
    _createElementVNode("div", {
      class: _normalizeClass({ 'main-content': !_ctx.captureClip && !_ctx.isCapturing, 'main-content-capture': _ctx.isCapturing })
    }, [
      (!_ctx.isDashboard)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.isDashboard)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            id: "content-download-area-dashboard",
            class: "transition jr-py-3.5 jr-overflow-auto",
            style: _normalizeStyle({ marginLeft: _ctx.sbMinimum ? '64px' : '240px' })
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", {
                class: _normalizeClass(["grid-box jr-flex jr-flex-col jr-relative jr-bg-white jr-rounded-md jr-w-12/25", { 'jr-shadow': !_ctx.captureClip }])
              }, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                  _withDirectives(_createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("span", null, _toDisplayString(_ctx.lessAmountMessage), 1)
                  ], 512), [
                    [_vShow, _ctx.isLessRanking]
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("ul", _hoisted_7, [
                      _createElementVNode("li", {
                        class: "jr-relative jr-inline-block jr-p-2.5 jr-cursor-pointer",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleTabChange(_ctx.TabType.ResidencePlace)))
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass([{
                    'jr-font-bold jr-text-blue-light' : _ctx.rankingTab === _ctx.TabType.ResidencePlace,
                    'jr-font-medium jr-text-gray': _ctx.rankingTab !== _ctx.TabType.ResidencePlace
                  }, "jr-text-sm"])
                        }, "居住地ランキング", 2),
                        _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
                          [_vShow, _ctx.rankingTab === _ctx.TabType.ResidencePlace]
                        ])
                      ]),
                      _createElementVNode("li", {
                        class: "jr-relative jr-inline-block jr-p-2.5 jr-cursor-pointer",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleTabChange(_ctx.TabType.WorkLocation)))
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass([{
                    'jr-font-bold jr-text-blue-light' : _ctx.rankingTab === _ctx.TabType.WorkLocation,
                    'jr-font-medium jr-text-gray': _ctx.rankingTab !== _ctx.TabType.WorkLocation
                  }, "jr-text-sm"])
                        }, "勤務地ランキング", 2),
                        _withDirectives(_createElementVNode("div", _hoisted_9, null, 512), [
                          [_vShow, _ctx.rankingTab === _ctx.TabType.WorkLocation]
                        ])
                      ])
                    ])
                  ]),
                  _withDirectives(_createElementVNode("ul", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.residents, (resident, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: _normalizeClass(["jr-text-base", { 'jr-mb-3': index < _ctx.residents.length - 1 }])
                      }, [
                        _createElementVNode("span", null, _toDisplayString(index + 1) + ". ", 1),
                        _createElementVNode("span", null, _toDisplayString(resident.name), 1),
                        _withDirectives(_createElementVNode("span", null, "(" + _toDisplayString(resident.percentage) + "%)", 513), [
                          [_vShow, resident.percentage]
                        ])
                      ], 2))
                    }), 128))
                  ], 512), [
                    [_vShow, _ctx.rankingTab === _ctx.TabType.ResidencePlace]
                  ]),
                  _withDirectives(_createElementVNode("ul", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workLocations, (wl, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: _normalizeClass(["jr-text-base", { 'jr-mb-3': index < _ctx.workLocations.length - 1 }])
                      }, [
                        _createElementVNode("span", null, _toDisplayString(index + 1) + ". ", 1),
                        _createElementVNode("span", null, _toDisplayString(wl.name), 1),
                        _withDirectives(_createElementVNode("span", null, "(" + _toDisplayString(wl.percentage) + "%)", 513), [
                          [_vShow, wl.percentage]
                        ])
                      ], 2))
                    }), 128))
                  ], 512), [
                    [_vShow, _ctx.rankingTab === _ctx.TabType.WorkLocation]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("div", _hoisted_13, null, 512), [
                    [_vShow, _ctx.isLoadingDetail]
                  ]),
                  _withDirectives(_createVNode(_component_router_link, {
                    to: "/area_report/ranking",
                    class: "jr-flex jr-items-center jr-my-3.5 jr-mx-5"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14,
                      _hoisted_15
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, !_ctx.isLoadingDetail && !_ctx.isLessRanking && _ctx.isLoaded]
                  ])
                ]),
                _withDirectives(_createVNode(_component_UILoader, null, null, 512), [
                  [_vShow, _ctx.isLoadingRanking]
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["grid-box jr-relative jr-flex jr-flex-col jr-relative jr-bg-white jr-rounded-md jr-w-12/25", { 'jr-shadow': !_ctx.captureClip }])
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.lessAmountMessage), 1)
                  ], 512), [
                    [_vShow, _ctx.isLessTransportation]
                  ]),
                  _withDirectives(_createVNode(_component_TransportationDashboardBarchart, null, null, 512), [
                    [_vShow, !_ctx.isLessTransportation]
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("div", _hoisted_22, null, 512), [
                    [_vShow, _ctx.isLoadingDetail]
                  ]),
                  _withDirectives(_createVNode(_component_router_link, {
                    to: "/area_report/transportation",
                    class: "jr-flex jr-items-center jr-my-3.5 jr-mx-5"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_23,
                      _hoisted_24
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, !_ctx.isLoadingDetail && !_ctx.isLessTransportation && _ctx.isLoaded]
                  ])
                ]),
                _withDirectives(_createVNode(_component_UILoader, null, null, 512), [
                  [_vShow, _ctx.isLoadingTransportation]
                ])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", {
                class: _normalizeClass(["grid-box jr-relative jr-flex jr-flex-col jr-relative jr-bg-white jr-rounded-md jr-w-12/25", { 'jr-shadow': !_ctx.captureClip }])
              }, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _withDirectives(_createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("span", null, _toDisplayString(_ctx.lessAmountMessage), 1)
                    ], 512), [
                      [_vShow, _ctx.isLessFacility]
                    ]),
                    _withDirectives(_createVNode(_component_FacilityBarChart, null, null, 512), [
                      [_vShow, !_ctx.isLessFacility]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _withDirectives(_createElementVNode("div", _hoisted_33, null, 512), [
                    [_vShow, _ctx.isLoadingDetail]
                  ]),
                  _withDirectives(_createVNode(_component_router_link, {
                    to: "/area_report/facilities",
                    class: "jr-flex jr-items-center jr-my-3.5 jr-mx-5"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_34,
                      _hoisted_35
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, !_ctx.isLoadingDetail && !_ctx.isLessFacility && _ctx.isLoaded]
                  ])
                ]),
                _withDirectives(_createVNode(_component_UILoader, null, null, 512), [
                  [_vShow, _ctx.isLoadingFacility]
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["grid-box jr-relative jr-flex jr-flex-col jr-relative jr-bg-white jr-rounded-md jr-w-12/25", { 'jr-shadow': !_ctx.captureClip }])
              }, [
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, [
                  _withDirectives(_createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("span", null, _toDisplayString(_ctx.lessAmountMessage), 1)
                  ], 512), [
                    [_vShow, _ctx.isLessTimeSpent || _ctx.isErrorTimeSpent]
                  ]),
                  _withDirectives(_createVNode(_component_TimingDoughnutChart, {
                    labels: _ctx.timeLabels,
                    data: _ctx.timeData,
                    average: _ctx.timeAverage,
                    width: 276,
                    height: 276,
                    cutout: 60
                  }, null, 8, ["labels", "data", "average"]), [
                    [_vShow, !_ctx.isLessTimeSpent && !_ctx.isErrorTimeSpent]
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _withDirectives(_createElementVNode("div", _hoisted_41, null, 512), [
                    [_vShow, _ctx.isLoadingDetail]
                  ]),
                  _withDirectives(_createVNode(_component_router_link, {
                    to: "/area_report/timing",
                    class: "jr-flex jr-items-center jr-my-3.5 jr-mx-5"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_42,
                      _hoisted_43
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, !_ctx.isLoadingDetail && !_ctx.isLessTimeSpent && _ctx.isLoaded]
                  ])
                ]),
                _withDirectives(_createVNode(_component_UILoader, null, null, 512), [
                  [_vShow, _ctx.isLoadingTimeSpent]
                ])
              ], 2)
            ]),
            (_ctx.showAreaVisitor === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["jr-relative jr-bg-white jr-rounded-md jr-w-full", { 'jr-shadow': !_ctx.captureClip }])
                  }, [
                    _hoisted_45,
                    _createElementVNode("div", _hoisted_46, [
                      _withDirectives(_createElementVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _createElementVNode("span", null, _toDisplayString(_ctx.lessAmountMessage), 1)
                      ], 512), [
                        [_vShow, _ctx.isLessVisitor || _ctx.isErrorVisitorChart || _ctx.isErrorVisitorDoughnut]
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _createVNode(_component_VisitorBarChart, {
                            label: "性別・年代別比",
                            labels: _ctx.visitorLabels,
                            men: _ctx.visitorMen,
                            women: _ctx.visitorWomen,
                            "show-bottom-label": false
                          }, null, 8, ["labels", "men", "women"])
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_component_VisitorDoughnutChart, {
                            label: "ペルソナ",
                            width: 290,
                            height: 290
                          })
                        ])
                      ], 512), [
                        [_vShow, !_ctx.isLessVisitor && !_ctx.isErrorVisitorChart && !_ctx.isErrorVisitorDoughnut]
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_52, [
                        _hoisted_53,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personas, (persona, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "jr-w-1/3 jr-mb-5.5 jr-px-3.5",
                            key: persona.id
                          }, [
                            _createVNode(_component_UIPersona, {
                              id: index + 1,
                              age: persona.age,
                              gender: persona.gender,
                              slogan: persona.slogan,
                              color: _ctx.personaColors[index],
                              avatar: persona.avatar
                            }, null, 8, ["id", "age", "gender", "slogan", "color", "avatar"])
                          ]))
                        }), 128))
                      ], 512), [
                        [_vShow, !_ctx.isLessVisitor && !_ctx.isErrorVisitorChart && !_ctx.isErrorVisitorDoughnut]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _withDirectives(_createElementVNode("div", _hoisted_55, null, 512), [
                        [_vShow, _ctx.isLoadingDetail]
                      ]),
                      _withDirectives(_createVNode(_component_router_link, {
                        to: "/area_report/visitor",
                        class: "jr-flex jr-items-center jr-my-3.5 jr-mx-5"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_56,
                          _hoisted_57
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, !_ctx.isLoadingDetail && !_ctx.isLessVisitor && _ctx.isLoaded]
                      ])
                    ]),
                    _withDirectives(_createVNode(_component_UILoader, null, null, 512), [
                      [_vShow, _ctx.isLoadingVisitor]
                    ])
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ], 4))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.isLoadingMaster)
      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}